import * as React from 'react';
import translate from '../i18n/translate';
export var ChartNotAvailable = function ChartNotAvailable() {
  return React.createElement("div", {
    className: "ChartNotAvailable"
  }, React.createElement("span", null, translate('ChartNotAvailable')));
};